export enum ImporterTypes {
  COURSES = 'Courses',
  COURSE_RESOURCES = 'Course Resources',
  LESSONS = 'Lessons',
  LESSON_PARTS = 'Lesson Parts',
  QUESTIONS = 'Questions',
  QUESTION_ANSWERS = 'Question Answers',
}
